import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-sample-select',
  templateUrl: './sample-select.component.html',
  styleUrls: ['./sample-select.component.scss']
})
export class SampleSelectComponent implements OnInit, OnChanges {

  @Input() block: any;
  @Input() positionBlock: any;
  @Input() resetValueCheckbox: boolean = false;
  @Output() valueForm = new EventEmitter();
  public checkboxGroupForm: FormGroup;
  public typeahead: FormControl = new FormControl();
  public suggestions: any;
  public checkArray!: Observable<any>;
  public titleDropdown: string = '';
  public isValue: boolean = false;


  get ordersFormArray() {
    return this.checkboxGroupForm.controls['checkbox'] as FormArray;
  }

  constructor(private formBuilder: FormBuilder) {
    this.checkboxGroupForm = this.formBuilder.group({
      checkbox: new FormArray([])
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resetValueCheckbox']) {
      this.checkboxGroupForm.reset();
      this.isValue = false;
      this.titleDropdown = this.block.titolo;
    }
  }

  ngOnInit(): void {
    this.addCheckboxes();
    this.titleDropdown = this.block.titolo;
    this.checkArray = of(this.block.value);
    this.typeahead.valueChanges.subscribe(searchKeyword => {
      if (searchKeyword === '') {
        this.checkArray = of(this.block.value);
      }
    });
  }

  private addCheckboxes() {
    this.block.value.forEach(() => this.ordersFormArray.push(new FormControl(false)));
  }

  setTitleDropdown(selectedCheckbox: [{ id: number, value: string }]) {

    if (selectedCheckbox.length === 1) {
      this.isValue = true;
      this.titleDropdown = selectedCheckbox[0].value;
    } else if (selectedCheckbox.length > 1) {
      this.isValue = true;
      this.titleDropdown = `${selectedCheckbox.length} ${this.block.titolo}`
    } else {
      this.isValue = false;
      this.titleDropdown = this.block.titolo;
    }
  }

  submit() {
    const selectedCheckbox = this.checkboxGroupForm.value.checkbox.map((checked: any, i: any) => checked ? this.block.value[i] : null).filter((v: null) => v !== null);
    this.valueForm.emit({
      id_block: this.block.id,
      values_selected: selectedCheckbox
    });
    this.setTitleDropdown(selectedCheckbox);
  }

  suggest() {
    this.suggestions = this.block.value.filter((c: any) => c.value.toLowerCase().includes(this.typeahead.value.toLowerCase())).slice(0, this.block.value.length);
    if (this.block.id === 3) {
      if (this.suggestions.length > 0) {
        this.checkArray = of(this.suggestions);
      }
    } else {
      this.checkArray = of(this.block.value);
    }
  }

}
